"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncSectionsMiddleware = void 0;
const graphql_1 = require("@app/gql-types/graphql");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const useSyncSectionsMiddleware = ({ toggleSection }) => {
    const syncSections = react_1.default.useCallback((details) => {
        if ((0, util_1.isValue)(details.note) && details.note.length > 0) {
            toggleSection('note', true);
        }
        const _attachments = details.attachments;
        if ((0, util_1.isValue)(_attachments) && _attachments.length > 0) {
            toggleSection('attachment', true);
        }
        if ((0, util_1.isValue)(details.recurrence)) {
            toggleSection('repeat', true);
        }
        // these conditions should be equivalent ideally
        if (((0, util_1.isValue)(details.workMinutesInclusion) ||
            ((0, util_1.isValue)(details.workMinutesBy) &&
                details.workMinutesBy !== graphql_1.TimeOffWorkMinutesBy.Settings)) &&
            (0, util_1.isValue)(details.workMinutes)) {
            // toggleSection('work-minutes-inclusion', true)
            toggleSection('default-work-minutes-inclusion', false);
        }
        const _periodType = details.periodType;
        if ((0, util_1.isValue)(_periodType) && _periodType !== graphql_1.PeriodType.WholeDay) {
            toggleSection('whole-day', false);
        }
    }, [toggleSection]);
    return syncSections;
};
exports.useSyncSectionsMiddleware = useSyncSectionsMiddleware;
